<template>
    <div class="col-md-6" id="cancellation-fee-block" >
        <label class="attribute-label m-bottom-12">Cancellation Fee</label>
        <div class="input-group width-100" >
            <input type="number" step="0.01" :name="`cancellation_fee`" :id="`cancellation_fee`" class="form-control price-new-inputs" v-model="fee" >
            <span class="input-group-addon input-group-addon-new-design" style="background-color: #F5F5F6 !important;">
                <b> {{ currency.currency_symbol }} </b>
            </span>
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";

export default {
    name: "BookingCancellationFee",
    props: ['currency','cancellationFee','confirmedFromPopup'],
    watch: {
        fee(val) {
            this.$emit('input', parseFloat(val))
        },
        deep:true
    },
    computed: {
        fee() {
            return this.confirmedFromPopup ? this.cancellationFee : 0;
        },
    },
    beforeDestroy() {
        this.$emit('reset-cancelation-fee');
    },
}
</script>

<style scoped>

</style>